import * as app from './scripts/Core/App';
import Map from './scripts/Modules/Map';
import Hotjar from './scripts/Modules/Hotjar';
import UltimasNotas from './scripts/Modules/UltimasNotas';
import ComprarEntradas from './scripts/Modules/ComprarEntradas';
import FuncionPeliculaPopup from './scripts/Modules/Popups/FuncionPeliculaPopup';

app.start().then(() => {
    const hotjar = new Hotjar();
    hotjar.tagRecording('sala');

    const map = new Map('mapid');
    map.Draw();

    // Evento del boton COMPRAR ENTRADAS
    ComprarEntradas.initialize();

    // init ultimas notas de cine
    const ultimasNotas = new UltimasNotas({ max: 3 });
    ultimasNotas.LoadUltimasDeCine();

    const $verhorarios = $('.verHorarios');
    $verhorarios.click(e => {
        var salaId = $(e.currentTarget).data("sala");
        var peliculaId = $(e.currentTarget).data("pelicula");
        FuncionPeliculaPopup.show(salaId, peliculaId);
    });
});


// WEBPACK FOOTER //
// ./Statics/Sala.js